import { trackEvent } from "@amplio-common/analytics";
import { selectParticipants, selectInitialSession, selectServiceType } from "@app/common/calendar/components/createSession/V3/store/CreateSessionSlice";

const getSessionDefaultProperties = (state) => {
  let numGroupsSet = 0;
  let numStudentsSetSepartely = 0;
  selectParticipants(state).forEach(p => p.startsWith("g") ? numGroupsSet += 1 : numStudentsSetSepartely += 1);
  const initialSession = selectInitialSession(state);

  return {
    num_groups_set: numGroupsSet,
    num_students_set_separtely: numStudentsSetSepartely,
    treatment_type: initialSession.type_id || state.createSession.typeId,
    treatment_id: initialSession.id,
    service_id: initialSession.sevice_id || selectServiceType(state),
  };
};


export const trackSessionEvent = (eventName, state, additionalParams = {}, callback = null) =>
  setTimeout(() => {
    try {
      trackEvent(eventName, { ...getSessionDefaultProperties(state), ...additionalParams });
      callback?.();
    } catch (e) {
      console.error(`failed to send student group analytics ${eventName}: ${e}`);
    }
  }, 1);
